import React, { memo, useMemo } from 'react'

import {
  Button,
  Icon,
  Bulb,
  GridShow,
  View360Arrow,
  CameraRotateReset,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, bool } from 'prop-types'

import DesktopOnlyTooltip from 'Pods/Shared/DesktopOnlyTooltip/DesktopOnlyTooltip'
import { iconSize } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { keepTooltipInViewport } from 'Pods/ThreeDStudio/Shared/Utils/keepTooltipInViewport'

import useMediaQuery from 'Utils/useMediaQuery'

import useViewerControls from '../../Hooks/useViewerControls'

function InnerViewerSidebar({
  onEnvironmentSettingsClick,
  isEnvironmentSettingsOpen,
}) {
  const t = useTranslation()
  const {
    grid,
    camera,
    toggleGrid,
    toggleAutoRotate,
    resetCamera,
  } = useViewerControls()

  const isSmallScreen = useMediaQuery('(max-width: 720px)')
  const buttons = useMemo(() => [
    {
      id: 'bulb',
      label: t('viewer.sidebar.lighting'),
      icon: Bulb,
      isActive: isEnvironmentSettingsOpen,
      onClick: onEnvironmentSettingsClick,
    },
    {
      id: 'toggle-grid',
      label: t('viewer.sidebar.toggleGrid'),
      isActive: grid?.visible,
      icon: GridShow,
      onClick: toggleGrid,
    },
    {
      id: 'view-360-arrow',
      label: t('viewer.sidebar.autoRotate'),
      isActive: camera?.autoRotate,
      icon: View360Arrow,
      onClick: toggleAutoRotate,
    },
    {
      id: 'camera-rotate-reset',
      label: t('viewer.sidebar.resetCamera'),
      icon: CameraRotateReset,
      onClick: resetCamera,
    },
  ], [
    grid,
    camera,
    isEnvironmentSettingsOpen,
    onEnvironmentSettingsClick,
    toggleGrid,
    toggleAutoRotate,
    resetCamera,
    t,
  ])

  return (
    <div className="inner-viewer-sidebar">
      {buttons.map(({ id, label, icon, isActive, onClick }, index) => (
        <React.Fragment key={id}>
          <DesktopOnlyTooltip
            content={label}
            id={`inner-viewer-sidebar-${id}-tooltip`}
            key={`inner-viewer-sidebar-${id}-tooltip`}
            place={isSmallScreen ? 'bottom' : 'left'}
            containerClass="inner-viewer-sidebar__tooltip"
            tooltipClassName="viewer-tooltip"
            overridePosition={keepTooltipInViewport}
          >
            <Button
              id={`inner-viewer-sidebar-${id}-button`}
              type="ghost"
              variant="only-icon"
              size="tiny"
              isActive={isActive}
              onClick={onClick}
              customClass="inner-viewer-sidebar__button"
              icon={(
                <Icon
                  svgComponent={icon}
                  color={isActive ? 'primary' : 'darker'}
                  size={iconSize}
                  notSpaced
                />
              )}
            />
          </DesktopOnlyTooltip>
          {index < buttons.length - 1 && <div className="inner-viewer-sidebar__divider" />}
        </React.Fragment>
      ))}
    </div>
  )
}

InnerViewerSidebar.propTypes = {
  onEnvironmentSettingsClick: func.isRequired,
  isEnvironmentSettingsOpen: bool.isRequired,
}

export default memo(InnerViewerSidebar)
